export default __webpack_public_path__ + "static/media/subcategory_car_8.388923c7.png";